import { Layout, Menu, Popover, Button, Drawer } from "antd";
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import menu from "../../constants/menu";
import UserIcon from "../../static/icon/UserIcon";
import PttFull from "../../static/icon/Ptt_full";
import { LogoutOutlined } from "@ant-design/icons";
import { useAuth } from "../../context/auth";

const Sidebar = ({ collapsed, broken, setCollapsed, setBroken, children }) => {
  const [pathname, setPathname] = useState("");
  const [visible, setVisible] = useState(false);
  const history = useHistory();
  const { adminRole, user, logout } = useAuth();

  useEffect(() => {
    const pathArray = history.location.pathname.split("/");
    if (pathArray[1] === 'promotion') setPathname(`/${pathArray[1]}/${pathArray[2]}`);
    else setPathname(`/${pathArray[1]}`);
  }, [history.location.pathname]);

  const left = collapsed ? (broken ? 0 : 80) : 250;
  const collapsedWidth = !broken ? 80 : 0;
  const opacity = collapsed ? 0 : 1;
  const className = collapsed ? "icon nav-icon-5 -mr-16" : "icon nav-icon-5 open";

  const menus = menu
    .filter(menu => menu.roles.includes(adminRole))
    .map((menu, i) => {
      if (menu.submenu)
        return {
          key: i,
          icon: menu.icon,
          label: menu.name,
          children: menu.submenu
            .filter(sub => !sub.roles || sub.roles.includes(adminRole))
            .map(sub => ({
              key: sub.path,
              label: <Link to={sub.path}>{sub.name}</Link>,
            }))
        };

      return {
        key: menu.path,
        icon: menu.icon,
        label: <Link to={menu.path}>{menu.name}</Link>,
      };
    }).concat([
      {
        key: '/user-detail',
        icon: <UserIcon style={{ fontSize: 20 }} />,
        label: <Link to="/user-detail">{user.firstName ?? ""} {user.lastName ?? ""}</Link>,
      },
      {
        key: '/logout',
        icon: <LogoutOutlined />,
        label: <Link to="/login">Log Out</Link>,
        onClick: () => logout(),
      },
    ]);

  const toggle = () => setCollapsed(!collapsed);
  const showDrawer = () => setVisible(true);
  const onClose = () => setVisible(false);

  return (
    <Layout>
      <Layout.Sider
        width={250}
        className="sidebar_"
        style={broken ? { left: 0, margin: 0, borderRadius: 0, height: "100vh" } : null}
        breakpoint="lg"
        collapsedWidth={collapsedWidth}
        onBreakpoint={(broken) => {
          setBroken(broken);
          if (broken) setCollapsed(true);
        }}
        trigger={null}
        collapsed={collapsed}
      >
        <div className="flex_ align_center" style={{ height: 50 }}>
          <div className="logo_name nav-text" style={{ opacity }}>
            EV Charging System
          </div>
          <div
            className={className}
            onClick={toggle}
            style={!collapsed ? { right: 10 } : { left: 28 }}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <Menu
          mode="inline"
          selectedKeys={[pathname]}
          style={{ border: "none" }}
          items={menus}
        />
      </Layout.Sider>
      <div className="layout_sid site" style={{ paddingLeft: left }}>
        <div className="story_header">
          <div className="flex_ align_items justify_center">
            <PttFull style={{ fontSize: 77, color: "#247cb3" }} />
            {broken && (
              <div
                className={className}
                onClick={showDrawer}
                style={{ marginLeft: 74, marginTop: 2 }}
              >
                <span></span>
                <span></span>
                <span></span>
              </div>
            )}
          </div>
          {broken && (
            <Popover
              placement="bottomLeft"
              title={<span style={{ fontSize: 14 }}>{adminRole}</span>}
              trigger="click"
            >
              <Button style={{ fontSize: 16 }} type="link">
                <UserIcon />
                {user.email ?? ""}
              </Button>
            </Popover>
          )}
        </div>
        {children}
      </div>
      <Drawer
        className="menu_sidebar"
        placement="left"
        onClose={onClose}
        open={visible}
      >
        <div className="logo">
          <PttFull style={{ fontSize: 77, color: "#247cb3" }} />
        </div>
        <Menu
          mode="inline"
          selectedKeys={[pathname]}
          style={{ border: "none" }}
          items={menus}
        />

        <div style={{ margin: 20 }} />
      </Drawer>
    </Layout>
  );
};

export default Sidebar;
